/** Module de gestion du localStorage pour mettre les données reçues d'Internet en cache */

export const constants = {
    LOCAL_STORAGE_NEWS: "NEWS_LIST",
    LOCAL_STORAGE_FILES: "FILES_LIST",
    LOCAL_STORAGE_USER: "USER"
}

/** Récupération des items. ceux-ci doivent être parsées */
export const getItem = (key) => {
    const item = localStorage.getItem(key)
    return JSON.parse(item)
}

/** On insère les items en local storage, ceux-ci sont stringify */
export const setItem = (key, item) => {
    localStorage.setItem(key, JSON.stringify(item))
}
